export default __webpack_public_path__ + "static/media/ToolBelt_home_screen.b7e48124.png";